import { useEffect, useState } from 'react';
import { gameStore } from '../store/gameStore';
import { loadingStore } from '../store/loadingStore';

export const useAssetsLoadedState = (ref) => {
  const [imagesLoadedState, setImagesLoadedState] = useState(false);
  const [webFontsLoaded, setWebFontsLoaded] = useState(false);
  const { isFakeImagesLoaded } = gameStore;

  useEffect(() => {
    async function areFontsReady() {
      await document.fonts.ready;
      setWebFontsLoaded(true);
    }

    areFontsReady();
  }, []);

  useEffect(() => {
    const updateStatus = (images) => {
      if (isFakeImagesLoaded) {
        setImagesLoadedState(images.every((image) => image.complete));
      }
    };
    if (!ref) return;
    const images = Array.from(ref.querySelectorAll('img'));

    if (!images || !images.length) {
      setImagesLoadedState(true);
      return;
    }

    const notLoadedImages = images.filter((item) => !item.complete);

    if (notLoadedImages && notLoadedImages.length) {
      notLoadedImages.forEach((image) => {
        image.addEventListener('load', () => updateStatus(images), {
          once: true,
        });
        image.addEventListener('error', () => updateStatus(images), {
          once: true,
        });
      });
    } else {
      isFakeImagesLoaded && setImagesLoadedState(true);
    }
  }, [ref, isFakeImagesLoaded]);

  useEffect(() => {
    if (imagesLoadedState && webFontsLoaded) {
      loadingStore.updateLoading({ isAssetsIsLoaded: true });
    }
  }, [imagesLoadedState, webFontsLoaded]);
};
